module.exports = __webpack_public_path__ + "static/img/thunder_card@2x.1258e48d.png";